import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../core/service/v2/abstractRepositoryV2";
import {ReportComponentModel} from "../../../api/entity/reportComponent.model";

@Injectable()
export class ReportComponentRepository extends AbstractRepositoryV2<ReportComponentModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ReportComponent', serviceElementsFactory, injector);
    }
}
